export const routes = [
  {
    path: '/index.html'
    ,alias: [
      '/'
    ]
    ,component: () => import('../index/index.vue')
  }
  // ,{
  //   path: '/ondex.html'
  //   ,component: () => import('../index/index.vue')
  // }
  // ,{
  //   path: '/study-trial.html'
  //   ,alias: [
  //     '/study-trial/index.html'
  //   ]
  //   ,component: () => import('../study-trial/index.vue')
  // }
]

export default routes
